import { Component, OnDestroy, ViewChild, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ResponseObterListasContato, ListaContato } from '../../../../interfaces/lista-contato/lista-contato.interface';
import { ListasService } from '../../../../services/listas.service';
import { Router } from '@angular/router';
import { EnumPermissao } from '../../../../enums/permissoes.enum';
import { ToastrService } from 'ngx-toastr';
import { PermissaoService } from '../../../../services/permissao.service';
import { AuthService } from '../../../../services/auth.service';
import { EnumTipoDownload } from '../../../../enums/tipo-arquivo-download.enum';
import { SaldoUtil } from '../../../../infra/saldo-util';
import { SaldoService } from '../../../../services/saldo.service';
import { FiltroSegmentacaoService } from '../../../../state-service/filtro-segmentacao.service';
import { FiltroSegmentacao } from '../../../../interfaces/segmentacao/filtro-segmentacao.interface';

@Component({
  selector: 'app-listas',
  standalone: false,
  templateUrl: './listas.component.html',
  styleUrl: './listas.component.css'
})
export class ListasComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private listasService: ListasService,
    private router: Router,
    private toastr: ToastrService,
    public permissaoService: PermissaoService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private saldoService: SaldoService,
    private filtroSegmentacaoService: FiltroSegmentacaoService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      const state = navigation.extras.state as any;
      this.paginaAtual = state.paginaAtual;
    }
  }

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  responseListas: ResponseObterListasContato = {
    totalListas: 0,
    listas: []
  };

  private dataLoaded = false;
  isLoading: boolean = false;
  exportandoLista: boolean = false;
  paginaAtual: number = 1;
  
  async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;
      const temPermissaoExportarLista = this.permissaoService.hasPermission(EnumPermissao.ExportarLista);
      const temPermissaoGerarSegmentacao = this.permissaoService.hasPermission(EnumPermissao.FazerSegmentacao);

      this.dtOptions = {
        dom: '<"row row-datatables"<"col-sm-12"tr>><"row row-datatables"<"col-sm-12 col-paging d-flex justify-content-center"p>>',
        order: [],
        serverSide: true,
        processing: false,
        searching: false,
        lengthChange: false,
        responsive: true,
        info: false,
        pageLength: 10,
        pagingType: 'simple_numbers',
        language: {
          processing: "Processando...",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ até _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 até 0 de 0 registros",
          infoFiltered: "(filtrado de _MAX_ registros no total)",
          infoPostFix: "",
          loadingRecords: "Carregando...",
          zeroRecords: "Nenhum registro encontrado",
          emptyTable: "Nenhuma lista disponível",
          paginate: {
            previous: "Anterior",
            next: "Próximo"
          }
        },
        columnDefs: [
          {
            targets: 0,
            createdCell: function (td: any, cellData: any, rowData: any, row: any, col: any) {
              $(td).addClass('text-brand-primary font-medium');
            }
          }
        ],
        columns: [
          {
            data: 'nomeLista',
            title: 'Lista',
            width: "40%",
            className: "",
            orderable: false,
            render: function (data: any, type: any, row: any) {
              return `<p class="text-brand-primary font-medium">
                      <a href="javascript:void(0)" 
                         class="lista-link" 
                         data-lista-id="${row.idLista}"
                         data-lista-nome="${row.nomeLista}">${row.nomeLista}</a>
                   </p>`;
            }
          },
          {
            data: 'filtro.abrangencia', title: 'Abrangência',
            width: "7%",
            className: "",
            orderable: false,
            render: (data: string[]) => data?.join(', ') || '-'
          },
          {
            data: 'dataCriacao', title: 'Data',
            width: "8%",
            className: "",
            orderable: false,
            render: (data: string) => new Date(data).toLocaleDateString('pt-BR'),
          },
          {
            data: 'qtdeExtracao',
            title: 'Contatos',
            type: 'text',
            width: "9%",
            className: "text-left",
            orderable: false,
          },
          {
            data: 'login',
            title: 'Usuário',
            width: "10%",
            className: "",
            orderable: false,
          },
          {
            data: null,
            title: '',
            orderable: false,
            className: "text-right",
            width: "26%",
            render: function (data: any, type: any, row: any) {
              let buttons = '';
              if (temPermissaoExportarLista) {
                buttons += `
                  <button class="btn btn-link btn-hidden baixar-lista" data-lista-id="${row.idLista}">
                    <span class="material-symbols-outlined filled">download_2</span>
                  </button>`;
              }

              if (temPermissaoGerarSegmentacao) {
                buttons += `
                  <div class="dropdown d-inline-block">
                    <button class="btn btn-link btn-hidden" type="button" id="dropdownMenu${row.idLista}" data-bs-toggle="dropdown" aria-expanded="false">
                      <span class="material-symbols-outlined filled">more_vert</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu${row.idLista}">
                      <li><a class="dropdown-item visualizar-segmentacao" href="javascript:void(0)" 
                            data-lista-id="${row.idLista}" data-filtro='${JSON.stringify(row.filtro)}'>
                            Carregar filtros</a></li>
                    </ul>
                  </div>`;
              } 
              return buttons;
            }
          }
        ],
        drawCallback: (settings: any) => {
          $('.baixar-lista').on('click', (event) => {
            const listaId = $(event.currentTarget).data('lista-id');
            this.baixarLista(listaId, event.currentTarget);
          });

          $('.lista-link').on('click', (event) => {
            const target = $(event.currentTarget);
            const listaId = target.data('lista-id');
            const nomeLista = target.data('lista-nome');

            localStorage.setItem('listaContatos', JSON.stringify({
              idLista: listaId,
              nomeLista: nomeLista
            }));

            this.router.navigate(['/area-logada/contatos']);
          });

          $('.visualizar-segmentacao').on('click', (event) => {
            const target = $(event.currentTarget);
            const filtro = target.data('filtro');
            this.navegarParaSegmentacao(filtro);
          });

          if (this.paginaAtual > 1) {
            const api = new $.fn.dataTable.Api(settings);
            api.page(this.paginaAtual - 1).draw('page');
          }
        },
        ajax: (dataTablesParameters: any, callback: any) => {
          this.isLoading = true;
          this.cdr.detectChanges();
          let pagina = this.paginaAtual > 1 ? this.paginaAtual : (dataTablesParameters.start / dataTablesParameters.length) + 1;
          localStorage.setItem('listaSalvaPagina', pagina.toString());
          this.listasService
            .obterListasContato(
              dataTablesParameters.length,
              pagina
            )
            .then(response => {
              if(this.permissaoService.hasPermission(EnumPermissao.VisualizarSegmentacoesOutrosUsuarios)) {
                this.responseListas = response;
              } else {
                const nomeUsuario = this.authService.getNomeUsuario();
                const listaFiltrada = response.listas.filter(lista => lista.login === nomeUsuario);
                this.responseListas = {
                  totalListas: listaFiltrada.length,
                  listas: listaFiltrada
                };
              }              
              callback({
                recordsTotal: response.totalListas,
                recordsFiltered: response.totalListas,
                data: response.listas
              });
              this.isLoading = false;
              this.paginaAtual = 0;
              this.cdr.detectChanges();
            })
            .catch(error => {
              console.error('Erro ao carregar listas:', error);
              this.isLoading = false;
              this.cdr.detectChanges();
            });
        }
      };
      this.dataLoaded = true;
    } catch (error) {
      console.error('Erro ao carregar listas:', error);
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  recarregarTabela(): void {
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: any) => {
        dtInstance.ajax.reload(null, false);
      });
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  async baixarLista(idLista: number, btn: any): Promise<void> {
    if (!this.permissaoService.hasPermission(EnumPermissao.ExportarLista)) {
      this.toastr.warning("Você não tem permissão para exportar listas", "Atenção");
      return;
    }

    if (this.exportandoLista) {
      this.toastr.warning("Uma exportação já está em andamento, aguarde a conclusão", "Atenção");
      return;
    }

    try {
      this.toastr.info("Download em andamento, aguarde a conclusão", "Atenção");
      this.exportandoLista = true;
      btn.disabled = true;
      const blob = await this.listasService.downloadListaContato(idLista, EnumTipoDownload.CSV);
      const url = window.URL.createObjectURL(blob.blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = blob.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      btn.disabled = false;
    } catch (error) {
      this.toastr.error('Erro ao baixar arquivo');
    } finally {
      this.exportandoLista = false;
    }
  }

  async navegarParaSegmentacao(filtro: FiltroSegmentacao) {
      this.filtroSegmentacaoService.atualizarFiltro(filtro);

      await SaldoUtil.navegarParaSegmentacao(
        this.saldoService,
        this.router,
        this.toastr
      );      
    }
}
